import context from '@truckdown/components-systems';
import { AddressStatus, IAddressValidator, IAuthenticator, LoginWithValidationTokenModel, ValidationResultModel } from '@truckdown/systems';
import { IUserManager, UserModel } from "@truckdown/accounts";
import { defineComponent, ref, Ref } from "vue";
//TODO: add import to API
import { ChangeEmailModel } from '@truckdown/accounts/Users/ChangeEmailModel';
import { email, required } from '@vuelidate/validators';
import { useVuelidate, Validation } from '@vuelidate/core';

interface IData {
    isLoading: Ref<boolean>,
    showAddressValidator: Ref<boolean>,
    usernameResetTrigger: Ref<number>,
    newEmail: Ref<string>,
    userProfile: Ref<UserModel>,
    errorMessage: Ref<string>
};

const validations = {
    newEmail: {
        email,
        required,
        $autoDirty: true
    }
};

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false),
        showAddressValidator: ref<boolean>(true),
        usernameResetTrigger: ref<number>(0),
        newEmail: ref<string>(''),
        userProfile: ref<UserModel>(props.userProfile),
        errorMessage: ref<string>('')
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any, validator: Ref<Validation>) {

    const validate = function () {
        validator.value.$touch();
        return validator.value.$validate()
            .then((res) => {
                return res;
            });
    }

    return {
        editEmailAddressCancelClick: function (): void {
            ctx.emit(userCancelEventName);
        },
        updateEmailAdmin: async function () {
            if (!data.isLoading.value) {
                data.isLoading.value = true;

                validate().then(async (res) => {
                    if (res) {
                        try {
                            data.errorMessage.value = '';
                            var userManager = await context.getService<IUserManager>('IUserManager');

                            var model = {
                                id: props.userProfile.id,
                                email: data.newEmail.value,
                                emailToken: "admin"
                            } as ChangeEmailModel;

                            let changeEmailResult = await userManager.changeEmail(model);
                            if (changeEmailResult && changeEmailResult.ok) {
                                data.userProfile.value.email = data.newEmail.value;
                                ctx.emit('update', changeEmailResult.data);
                            } else {
                                data.errorMessage.value = "Error updating email address: " + changeEmailResult.message;
                            }
                        } catch (err) {
                            data.errorMessage.value = "Error updating email address.";
                        } finally {
                            data.isLoading.value = false;
                        }
                    } else {
                        data.isLoading.value = false;
                    }
                });
            }
        },
        updateEmail: async function (type: string, res: ValidationResultModel) {
            if (res?.status == AddressStatus.Active || res?.status == AddressStatus.Inactive) {
                data.errorMessage.value = `${res.address} already exists in our system.`
            } else {
                data.errorMessage.value = '';
                var userManager = await context.getService<IUserManager>('IUserManager');
                let changeEmailResult = await userManager.changeEmail(
                    {
                        id: props.userProfile.id,
                        email: res.address,
                        emailToken: res.validationToken
                    } as ChangeEmailModel
                );

                if (changeEmailResult && changeEmailResult.ok) {
                    var authenticator = await context.getService<IAuthenticator>('IAuthenticator');
                    var loginResult = await authenticator.login({
                        username: res.address,
                        validationToken: res.validationToken
                    } as LoginWithValidationTokenModel);

                    if (loginResult && loginResult.ia) {
                        data.userProfile.value.email = res.address;

                        ctx.emit(userUpdatedEventName, data.userProfile.value);
                    } else {
                        data.errorMessage.value = "Error updating email address."
                    }
                } else {
                    data.errorMessage.value = "Updated successfully, please re-login for changes to take effect.";
                }
            }
        }
    }
}

const userUpdatedEventName = 'update';
const userCancelEventName = 'cancel';

export default defineComponent({
    props: {
        userProfile: {
            type: Object as () => UserModel,
            required: true
        },
        isAdmin: Boolean
    },
    components: {
    },
    emits: [userUpdatedEventName, userCancelEventName],
    setup: function (props, ctx) {

        let data = getInitialData(props);
        const v$ = useVuelidate(validations, data);

        let methods = getMethods(props, data, ctx, v$);

        return {
            ...data,
            ...methods,
            v$
        };
    }
});